<template>
  <span
    class="tw-flex tw-justify-center tw-items-center tw-gap-[10px] tw-w-[fit-content]"
    :class="`${isCheckCursor ? '' : 'tw-cursor-pointer'} tw-min-w-[20px]`"
    :data-cy="dataCy ? dataCy : 'base-checkbox-option'"
    @click="toggle"
  >
    <ToggleIcon
      :ticked="ticked"
      :color="color"
      :un-selected-color="unSelectedColor"
      :class="`${isCheckCursor ? '' : 'tw-cursor-pointer'} tw-min-w-[20px]`"
    />
    <span
      :class="[
        'tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[normal] tw-select-none',
        disabled ? '!tw-text-[#DBDBDB], tw-opacity-50 tw-cursor-wait' : '',
        textLeft && notYesNo ? '!tw-text-[#DBDBDB], tw-opacity-50' : '',
        textLeft ? 'tw-opacity-100' : '',
        textStyle,
      ]"
      :style="`${textLeft && notYesNo ? 'opacity: 0.5' : ''} ${
        textLeft && !notYesNo ? 'opacity: 1' : ''
      }`"
      >{{ text }}</span
    >
  </span>
</template>

<script setup lang="ts">
import ToggleIcon from "@/components/svgs/toggleIcon.vue";
import { data } from "jquery";
import { PropType, nextTick, onMounted, watch } from "vue";

const props = defineProps({
  color: {
    type: String as PropType<string>,
    default: "#DBDBDB",
  },
  text: {
    type: String as PropType<string>,
    default: "Checkbox",
  },
  ticked: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  disabled: {
    type: [String, Number, Boolean],
    default: false,
  },
  isDisabled: {
    type: [String, Number, Boolean],
    default: false,
  },
  textStyle: {
    type: String,
    default: "",
  },
  notYesNo: {
    type: Boolean,
    default: false,
  },
  textLeft: {
    type: String,
    default: "",
  },
  isCheckCursor: {
    type: Boolean,
    default: false,
  },
  dataCy: {
    type: String,
    default: "",
  },
  unSelectedColor: {
    type: String as PropType<string>,
    default: "#DBDBDB",
  },
});

const emits = defineEmits(["selected", "unselected", "onUpdate:ticked"]);

onMounted(() => {
  nextTick(function () {
    if (props.ticked) {
      emitter(true);
    }
  });
});
const toggle = () => {
  if (props.notYesNo) {
    return;
  } else if (props.notYesNo === false && props.textLeft) {
    emitter(!props.ticked);
    return;
  } else if (props.disabled !== 1) {
    emitter(!props.ticked);
  }
};

const emitter = (value: boolean) => {
  if (value) {
    emits("selected");
  } else {
    emits("unselected");
  }
  emits("onUpdate:ticked", value);
};
</script>

<style scoped>
.tick {
  transition: all 0.3s ease-in-out;
  opacity: 1;
}

.invisible {
  opacity: 0;
}

.tag-container {
  color: #fe9a05;
  background: var(
    --placeholder-orange-soft,
    linear-gradient(
      0deg,
      rgba(254, 154, 5, 0.15) 0%,
      rgba(254, 154, 5, 0.15) 100%
    ),
    #fff
  );
}
</style>
